export default __webpack_public_path__ + "circle-question.cca3b2d8.svg";